import { Heading, Icon, Text } from "@ttc3k/trekker";
import { WarningWindow } from "iconoir-react";
import { Trans, useTranslation } from "react-i18next";
import { WhereaboutsLogo } from "shared/components";
import { css } from "styled-system/css";
import { Center } from "styled-system/jsx";
import { HELPSCOUT_EMAIL } from "widgets/booker/shared/constants";

export const PageError = () => {
  const { t } = useTranslation("booker");
  return (
    <Center
      bg="bg.wa.lightest"
      height="100%"
      gap="300"
      flexDir="column"
      position="relative"
      px="300"
    >
      <Icon Element={WarningWindow} size="xl" color="icon.error.mid" />
      <Center flexDir="column" gap="100" textAlign="center">
        <Heading size="h5" color="text.dark">
          {t("ERROR_PAGE.TITLE")}
        </Heading>
        <Text color="text.mid">
          <Trans
            i18nKey={"booker:ERROR_PAGE.DESCRIPTION"}
            components={{
              Link: (
                <a
                  href={`mailto:${HELPSCOUT_EMAIL}`}
                  className={css({
                    textDecoration: "underline",
                    cursor: "pointer",
                  })}
                />
              ),
            }}
          />
        </Text>
      </Center>
      <Center position="absolute" bottom="600" flexDir="column" gap={"100"}>
        <Text color="text.light" visual="smallRegular">
          {t("POWERED_BY")}
        </Text>
        <WhereaboutsLogo width={110} height="auto" />
      </Center>
    </Center>
  );
};
